<template>
    <el-container id="tab">
        <el-main style="padding: 0;">
            <el-card shadow="never" style="height: calc(100% - 2px);">
                <el-card shadow="never" class="form-box">
                    <div class="form-left">
                        <template>
                            <span style="width: 60px;color: #606266;font-size: 14px;margin-right: 14px;">查询条件</span>
                            <el-input clearable style="margin-right: 20px;" size="small" v-model="selectUser.keyWords" @keyup.enter.native="onSubmit" placeholder="按车牌号查询"></el-input>
                        </template>
                        <el-button size="small" type="primary" @click="onSubmit">查询</el-button>
                        <!-- <el-checkbox :checked="selectUser.isFitterEnabled=='Y'" class="check" @change="checkChange">只显示可用仓库</el-checkbox> -->
                        <!-- <el-dropdown split-button size="small" type="primary" trigger="click">
                            <span @click="onSubmit">查询</span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>导入</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown> -->
                        <!-- <el-button size="small" @click="handleRightDelClick('null')">全部删除</el-button> -->
                    </div>
                    <div class="form-right">
                        <el-button size="small" @click="toAddUser()">添加</el-button>
                        <!-- <div class="form-help" style="margin-left: 20px;">
                            <el-button icon="el-icon-video-play" type="text"></el-button>
                            <span style="color: #409EFF;font-size: 14px;margin-left: 8px; cursor: pointer; line-height: 1.2;">帮助</span>
                        </div> -->
                    </div>
                </el-card>
                <div class="main-table">
                    <el-table :data="wareHouseList" stripe border style="width: 100%;" height="100%" max-height="100%" v-loading="loading" :row-class-name="tableCellClassName" @row-dblclick="handleTableDBClick" @filter-change="filterMethod">
                        <el-table-column type="index" :index="indexMethod" align="center">
                        </el-table-column>
                        <el-table-column prop="licenseNum" label="车牌号">
                        </el-table-column>
                        <el-table-column prop="vehicleType" label="车型" width="120">
                        </el-table-column>
                        <el-table-column prop="volume" width="120">
                            <template slot="header">
                                <span>体积(m<sup>3</sup>)</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="loadWeight" label="载量(吨)" width="120">
                        </el-table-column>
                        <el-table-column prop="oilWear" label="油耗(100km/L)" width="140">
                        </el-table-column>
                        <el-table-column prop="buyDate" label="购买日期" width="100">
                        </el-table-column>
                        <el-table-column prop="entryDate" label="录入日期" width="100">
                        </el-table-column>
                        <el-table-column prop="isEnabled" column-key="isEnabled" label="是否可用" width="90" :filter-multiple="false" :filters="[{text: '是', value: 'Y'}, {text: '否', value: 'N'}]">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.isEnabled === 'Y' ? 'success' : 'danger'" disable-transitions @click="handleRightTagClick(scope.$index)">{{ scope.row.isEnabled === 'Y' ? '是' : '否' }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="60">
                            <template slot-scope="scope">
                                <el-tooltip :hide-after="2000" class="item" effect="dark" content="复制" placement="top">
                                    <el-button style="margin-right: 5px;" @click="handleRightEditClick(scope.$index, 1)" icon="el-icon-copy-document" type="text"></el-button>
                                </el-tooltip>
                                <el-tooltip :hide-after="2000" class="item" effect="dark" content="编辑" placement="top">
                                    <i class="iconfont icon-bianji" @click="handleRightEditClick(scope.$index, 2)"></i>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column show-overflow-tooltip label="修改记录" width="80">
                            <template slot-scope="scope">
                                <el-link target="_blank" @click="handleRightDrawerClick(scope.$index)">修改记录</el-link>
                            </template>
                        </el-table-column> -->
                    </el-table>
                </div>
                <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="selectUser.page" :page-sizes="[10, 20, 100]" :page-size="selectUser.size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </el-card>
        </el-main>
        <el-dialog :lock-scroll="true" :title="title" :visible.sync="userVisible" width="700px" class="dialog-box" @close="dialogClose('ruleForm')" @opened="dialogOpen" :close-on-click-modal="false" :close-on-press-escape="false">
            <template>
                <el-form ref="ruleForm" :model="archives" size="small" :rules="branchRules" label-position="right" :inline="true" label-width="100px">
                    <div class="demo-ruleForm">
                        <el-form-item label="车牌号" prop="licenseNum">
                            <el-input ref="wareHouse" clearable v-model="archives.licenseNum" placeholder="必填" show-word-limit maxlength="60"></el-input>
                        </el-form-item>
                        <el-form-item label="车型" prop="vehicleType">
                            <el-input clearable v-model="archives.vehicleType"></el-input>
                        </el-form-item>
                    </div>
                    <div class="demo-ruleForm">
                        <el-form-item label="体积" prop="volume" class="demo-type">
<!--                            <el-input clearable v-model="archives.volume" placeholder="车厢的长×宽×高"></el-input>-->
                            <!-- <el-input-number v-model="archives.volume" :controls="false" :precision="2" :min="0" :max="99999999.99" placeholder="车厢的长×宽×高"></el-input-number> -->
                            <el-input-number :precision="3" :controls="false" :min="0" :max="99999999.999" v-model="archives.volume" placeholder="车厢的长×宽×高"></el-input-number>
                            <span style="margin-left: 5px; line-height: 1.2">m<sup>3</sup></span>
                            <div class="el-form-item__error">
                              请录入最小为0，最大为整数8位，小数3位（即99999999.999）之间的数字
                            </div>
                        </el-form-item>
                        <el-form-item label="载重" prop="loadWeight" class="demo-type">
<!--                            <el-input clearable v-model="archives.loadWeight"></el-input>-->
                            <el-input-number v-model="archives.loadWeight" :controls="false" :precision="2" :min="0" :max="99999999.99"></el-input-number>
                            <span style="margin-left: 5px; line-height: 1.2">吨</span>
                            <div class="el-form-item__error">
                              请录入最小为0，最大为整数8位，小数2位（即99999999.99）之间的数字
                            </div>
                        </el-form-item>
                    </div>
                    <div class="demo-ruleForm">
                        <el-form-item label="油耗" prop="oilWear" class="demo-type">
<!--                            <el-input clearable v-model="archives.oilWear"></el-input>-->
                            <el-input-number v-model="archives.oilWear" :controls="false" :precision="2" :min="0" :max="99999999.99"></el-input-number>
                            <span style="margin-left: 5px; line-height: 1.2">100km/L</span>
                            <div class="el-form-item__error">
                              请录入最小为0，最大为整数8位，小数2位（即99999999.99）之间的数字
                            </div>
                        </el-form-item>
                        <el-form-item label="购买时间" prop="buyDate">
                            <el-date-picker v-model="archives.buyDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                </el-form>
            </template>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogClose('ruleForm')">取消</el-button>
                <el-button size="small" type="primary" @click="onSubmitUser('ruleForm')">确定</el-button>
            </span>
        </el-dialog>
    </el-container>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            selectUser: {
                url: '/Account/vehicleDefineVue/selectVehicleList.html',
                keyWords: '',
                page: 1,
                size: 20,
                isEnabled: ''
            },
            wareHouseList: [],
            branchRules: {
                licenseNum: [{
                        required: true,
                        message: '请输入车牌号',
                        trigger: 'blur'
                    },
                    {
                        type: 'string',
                        required: true,
                        pattern: /^[\u4e00-\u9fa5a-zA-Z\d\(\)（）\_\-\·]+$/,
                        message: '请输入正确的车牌号',
                        trigger: 'blur'
                    }
                ],
            },
            total: 0,
            userVisible: false,
            loading: true,
            archives: {
                licenseNum: '',
                volume: '',
                loadWeight: '',
                oilWear: '',
                buyDate: '',
                vehicleType: ''
            },
            title: '',
            typeIndex: 0, //0.添加 1.复制 2.编辑
            submitClick: false,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            }
        }
    },
    created() {
        this.getUserList()
    },
    methods: {
        async getUserList() {
            this.loading = true
            const { data: res } = await this.$http.post(this.selectUser.url, this.Qs.stringify(this.selectUser))
            this.loading = false
            if (res.code != 'success') return this.$message.error(res.message)
            res.result = JSON.parse(res.result)
            this.wareHouseList = JSON.parse(res.result.data)
            this.total = res.result.total
        },
        onSubmit() { //查询
            console.log(233213)
            this.selectUser.page = 1
            this.getUserList()
        },
        typeChange(val) {
            if (val != 'C') {
                this.salesmanID.selected = {}
                this.archives.salesmanID = ''
                this.archives.salesmanName = ''
            }
        },
        handleRightEditClick(index, type) { //1.复制 2.编辑
            if (type == 1) {
                this.title = '复制添加车辆'
            } else if (type == 2) {
                this.title = '编辑车辆档案'
            }
            this.typeIndex = type
            this.tabIndex = index
            this.userVisible = true
        },
        handleCurrentChange(val) {
            this.selectUser.page = val
            this.getUserList()
        },
        toAddUser() { //打开添加弹窗
            this.title = '添加车辆档案'
            this.typeIndex = 0
            this.userVisible = true
        },
        onSubmitUser(form) {
            if (this.submitClick) return false
            this.submitClick = true
            console.log(this.archives)
            if (this.typeIndex == 2) {
                this.archives.url = '/Account/vehicleDefineVue/updateVehicle.html'
            } else {
                this.archives.url = '/Account/vehicleDefineVue/addVehicle.html'
                if (this.archives.id) delete this.archives.id
            }
            this.$refs[form].validate((valid) => {
                if (valid) {
                    this.toSubmit(form)
                } else {
                    this.submitClick = false
                }
            });
        },
        async toSubmit(form) {
            console.log(2342342)
            const { data: res } = await this.$http.post(this.archives.url, this.Qs.stringify(this.archives))
            this.submitClick = false
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
            this.getUserList()
            this.$refs[form].resetFields();
            this.userVisible = false
            this.tabIndex = null
            if (this.archives.id) delete this.archives.id
        },
        dialogClose(form) {
            this.$refs[form].resetFields();
            this.userVisible = false
            this.tabIndex = null
            this.submitClick = false
        },
        handleSizeChange(newSize) {
            this.selectUser.size = newSize
            this.getUserList()
        },
        handleRightDrawerClick(index) {
            this.drawerVisible = true
        },
        async handleRightTagClick(index) {
            let item = this.wareHouseList[index]
            let _isEnabled = item.isEnabled == 'Y' ? 'N' : 'Y'
            console.log(_isEnabled)
            const confirmResult = await this.$confirm('此操作为修改可用状态操作, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)
            if (confirmResult !== 'confirm') return this.$message.info('取消修改')
            const loading = this.$loading({
                lock: true,
                text: '修改中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            const { data: res } = await this.$http.post('/Account/vehicleDefineVue/updateCancelVehicle.html', this.Qs.stringify({ isEnabled: _isEnabled, id: item.id }))
            loading.close()
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
            this.selectUser.page = 1
            this.getUserList()
        },
        dialogOpen() {
            this.$refs['ruleForm'].resetFields();
            if (this.typeIndex > 0) {
                let item = this.wareHouseList[this.tabIndex]
                console.log(item)
                this.archives = { ...this.archives, ...item }
                if (this.typeIndex == 1) delete this.archives.warehouseID
            } else {
                this.archives = {
                    licenseNum: '',
                    vehicleType: '',
                    volume: '',
                    loadWeight: '',
                    oilWear: '',
                    buyDate: '',
                }
            }
        },
        handleTableDBClick(row) {
            this.handleRightEditClick(row.index, 2)
        },
        indexMethod(index) {
            return ((this.selectUser.page - 1) * this.selectUser.size) + (index + 1)
        },
        tableCellClassName({ row, column, rowIndex, columnIndex }) {
            row.index = rowIndex;
        },
        // 筛选是否可用
        filterMethod({ isEnabled }) {
            this.selectUser.isEnabled = isEnabled.length ? isEnabled[0] : ''
            this.selectUser.page = 1
            this.getUserList()
        }
    }
}
</script>
<style scoped src="@/assets/font/tableButtonIcon.css"></style>
<style scoped lang="less">
#tab {

    /deep/.el-card__body {
        padding: 10px 15px;
        height: calc(100% - 20px);
    }

    /deep/.el-button--text {
        padding: 0;
    }

    .icon-bianji,
    /deep/.el-icon-delete,
    /deep/.el-icon-video-play,
    /deep/.el-icon-copy-document,
    /deep/.el-icon-map-location {
        font-size: 16px;
        color: #409EFF;
        font-weight: 400;
        cursor: pointer;
    }

    .form-box {
        /deep/.el-card__body {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }

        .form-right,
        .form-help {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
        }

        .form-left {
            width: 70%;

            .el-input {
                width: 30%;
            }

            .el-dropdown__icon {
                font-size: 14px;
            }

            .check {
                margin-left: 80px;
            }
        }

        .form-right {
            width: 40%;
        }
    }

    .main-table {
        margin-top: -1px;
        height: calc(100% - 85px);

        /deep/.el-table__body {
            td,
            th {
                padding: 6px 0;
            }

            tr {
                cursor: pointer;
            }
        }
    }

    .demo-ruleForm {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        /deep/.el-form-item {
            flex: 1;
            margin-right: 0;
            margin-bottom: 22px;
            display: flex;
            flex-direction: row;
            align-items: center;
        }

        .demo-type {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 30px;
            /deep/.el-form-item__content {
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 70%;
            }

            /deep/.el-input {
                //width: 70%;
            }
        }
    }

    .dialog-footer {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .dialog-box {
        /deep/.el-dialog__body {
            padding: 10px 20px 0;
        }

        /deep/.el-dialog__footer {
            padding-top: 0;
        }
    }

    /deep/.el-dialog {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        top: 50%;
        transform: translateY(-50%);
    }
}
</style>